import { PaymentMethod } from "@/domain/entities/payment/paymentMethod";
import { IPaymentMethod } from "@/domain/entities/payment/paymentMethod.types";
import {
  HttpPGCode,
  HttpPaymentMethod,
  IPaymentMethodParser,
} from "@/repositories/payment/paymentRepository.types";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { PGCode } from "@/types";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";

function parsePGCode(code: HttpPGCode) {
  switch (code) {
    case HttpPGCode.KCP:
      return PGCode.KCP;
    case HttpPGCode.KakaoPay:
      return PGCode.KakaoPay;
    case HttpPGCode.FREE:
      return PGCode.FREE;
  }
}

function parseDisplayText(code: HttpPGCode) {
  switch (code) {
    case HttpPGCode.KCP:
      return "신용카드";
    case HttpPGCode.KakaoPay:
      return "카카오페이";
    case HttpPGCode.FREE:
      return "예약하기";
    default:
      return "";
  }
}

@injectable()
export class PaymentMethodParser implements IPaymentMethodParser {
  constructor() {}

  toDomain(data: HttpPaymentMethod): Result<IPaymentMethod, ParseError> {
    try {
      const paymentMethodData: IPaymentMethod = {
        pgCode: parsePGCode(data.code),
        name: data.name,
        displayText: parseDisplayText(data.code),
      };
      const paymentMethod = new PaymentMethod(paymentMethodData);
      return ok(paymentMethod);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
